import { get } from "lodash";
import { CONFIGURATOR_VALUE_UPDATE, SET_PRODUCTS, SET_HANDBOOK_FILE, PRODUCT_VALUE_UPDATE, SET_CONFIGURATOR_ID, SHOW_MORE_PRODUCT_INFO_POPUP, 
    SET_PRE_CHECKOUT_TEXT, CONFIGURATOR_VALUE_SHARE_UPDATE } from "../Actions/Configurator/Configurator.action";

const defaultState = { 
    payload: {
        products: [],
        configuratorValues: [],
        handBookFile: "",
        configuratorId: "",
        showConfiguratorMoreProductInfoPopUp: false,
        preCheckoutText: "",
        configuratorValuesShareData: [],
    }, 
    errors: {},
    result: {},     
}

export const productConfigurator = (state = defaultState, action) => {
    const { type, payload } = action;
    if (payload) {        
        switch (type) {
            case CONFIGURATOR_VALUE_UPDATE:        
                return {     
                    ...state,                        
                    payload: {
                        ...state.payload,                                              
                    },                  
                };
            case SET_PRODUCTS:
                return {
                    ...state,
                    payload: {
                        ...state.payload,
                        products: payload,
                    },
                };
            case SET_HANDBOOK_FILE:
                return {
                    ...state,
                    payload: {
                        ...state.payload,
                        handBookFile: payload,
                    },
                };
            case SET_PRE_CHECKOUT_TEXT:
                    return {
                        ...state,
                        payload: {
                            ...state.payload,
                            preCheckoutText: payload,
                        },
                    };
            case SET_CONFIGURATOR_ID:
                return {
                    ...state,
                    payload: {
                        ...state.payload,
                        configuratorId: payload,
                    },
                };
            case SHOW_MORE_PRODUCT_INFO_POPUP:
                return {
                    ...state,
                    ...action.payload                 
                };
            case PRODUCT_VALUE_UPDATE:
            const { articleNumber, newQuantity } = payload;
            return {
                ...state,
                payload: {
                    ...state.payload,
                    products: state.payload.products.map(product => 
                        product.articleNumber === articleNumber 
                            ? { ...product, confirmedQuantity: newQuantity, added: newQuantity > 0 }
                            : product
                    ),
                },
            };
            case CONFIGURATOR_VALUE_SHARE_UPDATE:        
                return {     
                    ...state,                        
                    payload: {
                        ...state.payload,
                        configuratorValuesShareData: payload,
                    },                  
                };
            default:
                return state;
        }
    }
    return state;    
}